<template>
    <div>
        <a href="#" @click.prevent="clickHandler" class="button is-block is-primary hyper6 bold">
            {{ $t('web.travel-sim.book-now') }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {

        },

        methods: {
            clickHandler(){
                this.$events.$emit('product-bottom-bar:showTopBar');
            }
        },

        mounted() {

        }
    }
</script>
